(() => {
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const scrollToPurchase = () => {
    const target = document.querySelector('product-info variant-selects') || document.getElementById('StavoraPurchase');
    if (!target) return;
    target.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'center' });
    const control = target.querySelector('input:not([disabled]),select:not([disabled])');
    if (control) window.setTimeout(() => control.focus({ preventScroll: true }), reduceMotion() ? 0 : 450);
  };
  let opener = null;
  const openDialog = (id, trigger) => {
    const dialog = document.getElementById(id);
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    opener = trigger;
    if (!dialog.open) dialog.showModal();
    return true;
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="#Stavora"]');
    if (link && !link.hasAttribute('data-sv-dialog')) {
      const url = new URL(link.href, window.location.href);
      if (url.origin === window.location.origin && openDialog(url.hash.slice(1), link)) {
        event.preventDefault();
        return;
      }
    }
    const trigger = event.target.closest('[data-sv-dialog]');
    if (trigger) {
      if (openDialog(trigger.dataset.svDialog, trigger)) event.preventDefault();
      return;
    }
    const closer = event.target.closest('[data-sv-close]');
    if (closer) {
      closer.closest('dialog')?.close();
      opener?.focus({ preventScroll: true });
      return;
    }
    const purchase = event.target.closest('[data-sv-purchase]');
    if (purchase && document.getElementById('StavoraPurchase')) {
      event.preventDefault();
      scrollToPurchase();
    }
  });
  const init = () => {
    document.querySelectorAll('.sv-dialog').forEach((dialog) => {
      if (dialog.dataset.svReady) return;
      dialog.dataset.svReady = 'true';
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        }
      });
      dialog.addEventListener('close', () => opener?.focus({ preventScroll: true }));
    });
    document.querySelectorAll('[data-sv-plan]').forEach((planner) => {
      if (planner.dataset.svReady) return;
      planner.dataset.svReady = 'true';
      const render = () => {
        const pieces = [...planner.querySelectorAll('[data-sv-unit]')].map((unit) => {
          const color = unit.querySelector('[data-sv-color]');
          const size = unit.querySelector('[data-sv-size]');
          return `${unit.dataset.svUnit}: ${color.options[color.selectedIndex].text}, ${size.options[size.selectedIndex].text}`;
        });
        planner.querySelector('[data-sv-plan-output]').textContent = pieces.join(' · ');
      };
      const configNode = planner.querySelector('[data-sv-pair-config]');
      if (configNode) {
        const config = JSON.parse(configNode.textContent);
        const add = planner.querySelector('[data-sv-add-pair]');
        const status = planner.querySelector('[data-sv-pair-status]');
        add.addEventListener('click', async () => {
          if (add.disabled) return;
          const units = [...planner.querySelectorAll('[data-sv-unit]')];
          const missing = units.find(unit => !unit.querySelector('[data-sv-size]').value);
          if (missing) {
            status.textContent = config.choose;
            missing.querySelector('[data-sv-size]').focus();
            return;
          }
          const variants = units.map(unit => config.variants.find(variant =>
            variant.side === unit.dataset.svSide &&
            variant.color === unit.querySelector('[data-sv-color]').value &&
            variant.size === unit.querySelector('[data-sv-size]').value));
          if (variants.some(variant => !variant || !variant.available)) {
            status.textContent = config.unavailable;
            return;
          }
          add.disabled = true;
          add.setAttribute('aria-busy', 'true');
          status.textContent = config.adding;
          try {
            const response = await fetch(config.addUrl, {
              method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: variants.map(variant => ({ id: variant.id, quantity: 1 })) })
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || config.error);
            // The successful add-to-cart request above remains unchanged.
            // Verify the server-side cart before attempting the optional drawer.
            try {
              const cartResponse = await fetch(config.cartUrl + '.js', { credentials: 'same-origin', cache: 'no-store' });
              if (!cartResponse.ok) throw new Error('cart');
              const cart = await cartResponse.json();
              const expected = variants.map(v => Number(v.id));
              if (!expected.every(id => cart.items.some(item => Number(item.variant_id) === id))) throw new Error('missing-items');
              const drawer = document.querySelector('cart-drawer');
              if (!drawer || typeof drawer.renderContents !== 'function') throw new Error('no-drawer');
              const sectionsResponse = await fetch('/?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin', cache: 'no-store' });
              if (!sectionsResponse.ok) throw new Error('sections');
              const sections = await sectionsResponse.json();
              if (!sections['cart-drawer'] || !sections['cart-icon-bubble']) throw new Error('missing-sections');
              const parsedDrawer = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
              const newDrawer = parsedDrawer.querySelector('#CartDrawer');
              if (!newDrawer || !newDrawer.querySelector('cart-drawer-items .cart-item')) throw new Error('empty-drawer');
              // Replace the actual drawer body, not Shopify's section wrapper.
              // Validate both the fetched HTML and the final DOM before opening.
              const freshInner = newDrawer.querySelector('.drawer__inner');
              const currentInner = drawer.querySelector('.drawer__inner');
              if (!freshInner || !currentInner || freshInner.querySelectorAll('.cart-item').length < cart.items.length) throw new Error('incomplete-drawer');
              currentInner.replaceWith(document.importNode(freshInner, true));
              drawer.classList.remove('is-empty');
              if (drawer.querySelectorAll('.cart-item').length < cart.items.length) throw new Error('unrendered-items');
              drawer.open();
              add.disabled = false;
              add.removeAttribute('aria-busy');
              status.textContent = '';
            } catch (drawerError) {
              window.location.assign(config.cartUrl);
            }
          } catch (error) {
            status.textContent = error.message || config.error;
            add.disabled = false;
            add.removeAttribute('aria-busy');
          }
        });
      }
      planner.addEventListener('change', render);
      render();
    });
    const sticky = document.querySelector('[data-sv-sticky]');
    const buyButtons = document.querySelector('product-info .product-form__buttons');
    if (sticky && buyButtons && !sticky.dataset.svReady && 'IntersectionObserver' in window) {
      sticky.dataset.svReady = 'true';
      let passedPurchase = false;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          passedPurchase = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          sticky.hidden = !passedPurchase;
        });
      });
      observer.observe(buyButtons);
      const footer = document.querySelector('.sv-service-footer');
      if (footer) new IntersectionObserver((entries) => {
        entries.forEach((entry) => { sticky.hidden = entry.isIntersecting || !passedPurchase; });
      }, { threshold: 0.1 }).observe(footer);
    }
    const hash = window.location.hash.slice(1);
    if (hash.startsWith('StavoraPolicy') || hash === 'StavoraSizeDialog' || hash === 'StavoraFAQDialog') openDialog(hash, null);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('hashchange', () => {
    const id = window.location.hash.slice(1);
    if (id.startsWith('StavoraPolicy') || id === 'StavoraSizeDialog' || id === 'StavoraFAQDialog') openDialog(id, null);
  });
})();


(()=>{const init=()=>{document.querySelectorAll('[data-sv-choice]').forEach(c=>{if(c.dataset.ready)return;c.dataset.ready='1';const update=()=>{const pair=c.querySelector('input:checked').value==='pair';c.querySelector('[data-sv-pair-panel]').hidden=!pair;c.querySelector('[data-sv-single-hint]').hidden=pair;const info=c.closest('product-info');if(info)info.dataset.svOrderMode=pair?'pair':'single';};c.addEventListener('change',update);update();});document.querySelectorAll('[data-sv-reviews]').forEach(track=>{if(track.dataset.ready)return;track.dataset.ready='1';let timer;const play=()=>{if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;clearInterval(timer);timer=setInterval(()=>{const next=track.querySelector('[data-current]')?.nextElementSibling||track.firstElementChild;track.querySelector('[data-current]')?.removeAttribute('data-current');next?.setAttribute('data-current','');if(next)track.scrollTo({left:next.offsetLeft-track.offsetLeft,behavior:'smooth'});},6000);};track.addEventListener('mouseenter',()=>clearInterval(timer));track.addEventListener('focusin',()=>clearInterval(timer));track.addEventListener('mouseleave',play);play();});};document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init();document.addEventListener('shopify:section:load',init);})();